<mat-card class="mat-elevation-z8 card-select-billets">
    <mat-card-header>
        <mat-card-title class="text-primary">Selecione outra parcela:</mat-card-title>
    </mat-card-header>
    <p class="ml-5 text-primary">Valor recebido: {{ json.Amount | currency }}</p>
    <p class="ml-5 text-warning">Saldo: {{ selectedSumDisponible | currency }}</p>
    <p class="ml-5 text-success">Valor de boleto(s): {{ selectedSum | currency }}</p>

    <button
        id="btnConfirmSelect"
        class="float-right btn-sm"
        mat-button
        mat-raised-button
        color="primary"
        (click)="doneSelectBillets()"
        [disabled]="_loaderService.isLoading | async">
        <mat-icon>check</mat-icon> Confirmar
    </button>

    <table class="table tableCustom pointer">
        <thead>
            <tr>
                <th class="text-muted">Contrato</th>
                <th class="text-muted">Vencimento</th>
                <th class="text-muted">Fatura</th>
                <th class="text-muted">Valor</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let groupKey of groupedKeys">
                <!-- Cabeçalho do Grupo, colapsável -->
                <tr (click)="toggleCollapse(groupKey)" class="group-header">
                    <td colspan="4">
                        <strong>{{ groupKey }}</strong>
                        <mat-icon>
                            {{ collapseStates[groupKey] ? 'expand_more' : 'expand_less' }}
                        </mat-icon>
                    </td>
                </tr>

                <!-- Linhas do grupo, mostradas se o colapso estiver desativado -->
                <ng-container *ngIf="!collapseStates[groupKey]">
                    <tr
                        *ngFor="let billet of groupedBillets[groupKey]"
                        (click)="toggleSelectLine(billet)"
                        [class.selected]="isSelected(billet)">
                        <td>{{ billet.contractDescription }}</td>
                        <td>{{ billet.dueDate | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ billet.number }}</td>
                        <td class="d-flex">
                            <span>{{ billet.billetValue | currency }}</span>

                            <div *ngIf="json.Amount > billet.billetValue">
                                <abbr title="PGM MAIOR">
                                    <mat-icon matTooltip="PGM MAIOR" color="accent">arrow_drop_up</mat-icon>
                                </abbr>
                            </div>
                            <div *ngIf="json.Amount < billet.billetValue">
                                <abbr title="PGM MENOR">
                                    <mat-icon matTooltip="PGM MENOR" color="warn">arrow_drop_down</mat-icon>
                                </abbr>
                            </div>
                            <div *ngIf="json.Amount == billet.billetValue">
                                <abbr title="PGM MESMO VALOR">
                                    <mat-icon matTooltip="PGM MESMO VALOR">check</mat-icon>
                                </abbr>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </tbody>
    </table>
</mat-card>
